import { render, staticRenderFns } from "./ProjectOwnerRequestForm.vue?vue&type=template&id=fa0b896a"
import script from "./ProjectOwnerRequestForm.vue?vue&type=script&lang=ts"
export * from "./ProjectOwnerRequestForm.vue?vue&type=script&lang=ts"
import style0 from "./ProjectOwnerRequestForm.vue?vue&type=style&index=0&id=fa0b896a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports